export const ORDER_ROW_DIALOG_BLOCK_SELECTOR =
  "input, button, .repair-atelier-option, .select-cell, .repair-instock-date-cell";

export function blocksOrderDialog(target: EventTarget | null): boolean {
  const candidate = target as (EventTarget & Partial<Pick<Element, "closest">>) | null;
  return Boolean(candidate?.closest?.(ORDER_ROW_DIALOG_BLOCK_SELECTOR));
}
